import React, { useState, useEffect } from "react";
import api from "../Service/api";
import "./EmployeeView.css";

export default function EmployeeView() {
  const [employees, setEmployees] = useState([]);
  const [search, setSearch] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({
    name: "",
    address: "",
    designation: "",
    contactNumber: "",
    salary: "",
    salaryType: "MONTHLY",
  });

  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    try {
      const res = await api.get("/api/employees");
      setEmployees(res.data.additionalDetail || []);
    } catch (err) {
      console.error(err);
      alert("Error fetching employees. Check console.");
    }
  };

  const handleSearch = (e) => setSearch(e.target.value);

  const handleEditChange = (e) =>
    setEditForm({ ...editForm, [e.target.name]: e.target.value });

  const startEditing = (emp) => {
    setEditingId(emp.id);
    setEditForm({
      name: emp.name,
      address: emp.address,
      designation: emp.designation,
      contactNumber: emp.contactNumber,
      salary: emp.salary,
      salaryType: emp.salaryType || "MONTHLY",
    });
  };

  const cancelEditing = () => {
    setEditingId(null);
    setEditForm({
      name: "",
      address: "",
      designation: "",
      contactNumber: "",
      salary: "",
      salaryType: "MONTHLY",
    });
  };

  const updateEmployee = async (id) => {
    try {
      await api.put(`/api/employees/${id}`, editForm);
      alert("Employee updated successfully!");
      cancelEditing();
      fetchEmployees();
    } catch (err) {
      console.error(err);
      alert("Error updating employee. Check console.");
    }
  };

  const deleteEmployee = async (id) => {
    if (!window.confirm("Are you sure you want to delete this employee?")) return;
    try {
      await api.delete(`/api/employees/${id}`);
      alert("Employee deleted successfully!");
      fetchEmployees();
    } catch (err) {
      console.error(err);
      alert("Error deleting employee. Check console.");
    }
  };

  const filteredEmployees = employees.filter((e) =>
    e.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="container">
      <h1>👨‍💼 Employee Directory</h1>

      <div className="search-bar">
        <input
          type="text"
          placeholder="Search by name..."
          value={search}
          onChange={handleSearch}
        />
      </div>

      <div className="table-card">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Designation</th>
              <th>Contact</th>
              <th>Salary</th>
              <th>Salary Type</th>
              <th>Address</th>
              <th>ID Card</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredEmployees.map((e) => (
              <tr key={e.id}>
                <td>{e.id}</td>
                <td>
                  {editingId === e.id ? (
                    <input name="name" value={editForm.name} onChange={handleEditChange} />
                  ) : (
                    e.name
                  )}
                </td>
                <td>
                  {editingId === e.id ? (
                    <input
                      name="designation"
                      value={editForm.designation}
                      onChange={handleEditChange}
                    />
                  ) : (
                    e.designation
                  )}
                </td>
                <td>
                  {editingId === e.id ? (
                    <input
                      name="contactNumber"
                      value={editForm.contactNumber}
                      onChange={handleEditChange}
                    />
                  ) : (
                    e.contactNumber
                  )}
                </td>
                <td>
                  {editingId === e.id ? (
                    <input
                      name="salary"
                      type="number"
                      value={editForm.salary}
                      onChange={handleEditChange}
                    />
                  ) : (
                    e.salary
                  )}
                </td>
                <td>
                  {editingId === e.id ? (
                    <select
                      name="salaryType"
                      value={editForm.salaryType}
                      onChange={handleEditChange}
                    >
                      <option value="MONTHLY">Monthly</option>
                      <option value="WEEKLY">Weekly</option>
                      <option value="DAILY">Daily</option>
                    </select>
                  ) : (
                    e.salaryType || "MONTHLY"
                  )}
                </td>
                <td>
                  {editingId === e.id ? (
                    <input
                      name="address"
                      value={editForm.address}
                      onChange={handleEditChange}
                    />
                  ) : (
                    e.address
                  )}
                </td>
                <td>
                  {e.idCardImage ? (
                    <a href={e.idCardImage} target="_blank" rel="noopener noreferrer">
                      View
                    </a>
                  ) : (
                    "No File"
                  )}
                </td>
                <td>
                  {editingId === e.id ? (
                    <div className="action-group">
                      <button className="submit-btn" onClick={() => updateEmployee(e.id)}>
                        Save
                      </button>
                      <button className="remove-btn" onClick={cancelEditing}>
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <div className="action-group">
                      <button
                        className="action-btn update-btn"
                        onClick={() => startEditing(e)}
                      >
                        Edit
                      </button>
                      <button
                        className="action-btn delete-btn"
                        onClick={() => deleteEmployee(e.id)}
                      >
                        Delete
                      </button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
            {filteredEmployees.length === 0 && (
              <tr>
                <td colSpan="9" style={{ textAlign: "center" }}>
                  No employees found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
